import React, { Component } from "react";

export default class Testimonials extends Component {
	constructor() {
      super();
			this.state={

  }
	}
	render() {
		const testimonials = [
			{
				initials: "R.R",
				name: "R.R",
				location: "Pacifica, CA",
				rating: 5,
				text: "Called Dan & Dan (Pacific) they came out same day. I had a broken spring it was fixed in one hour. Nice people, great work, fair price! I would use them again and highly recommend them for your garage door needs."
			},
			{
				initials: "Rory L",
				name: "Rory L",
				location: "Pacifica, CA",
				rating: 5,
				text: "Highly recommend this Father and son team for any and all garage door needs. Great work in fixing our slightly prehistoric garage door and now as a result of their efforts we have a quieter and much more efficient garage door. Dan explained everything upfront and is an honest broker."
			},
			{
				initials: "Jeffery M",
				name: "Jeffery M",
				location: "El Granada, CA",
				rating: 5,
				text: "My old Genie garage door opener had finally bitten the dust after many months of screeching painful protest. I called Pacific Garage Doors to see what they could do for me. Dan, the father, answered and said he could come out first thing the next morning. True to his word he showed up accompanied by Dan, the son. Easy pricing, good conversation, and three hours later I have a silently running Liftmaster and new rollers. Talk about easy peasy....I HIGHLY recommend Pacific and the Dan and Dan team."
			},
			{
				initials: "David M",
				name: "David M",
				location: "San Francisco, CA",
				rating: 5,
				text: "This father-and-son team deserves more than five stars. We first encountered them when we needed someone to look at our existing garage door setup and offer advice. They spent a good 30 minutes working on our garage door and didn't charge us a dime. Several months later we decided to replace the entire door with a Sonoma style door with decorative hardware. Needless to say, they did a flawless job. Dan Jr. was extremely particular about getting the decorative hardware just so, which my wife and I appreciated. The garage door is now one of our favorite features on our old home. We have subsequently purchased a new home, and the garage door immediately failed. Dan Sr. picked up the phone despite the long holiday weekend, and he sent Dan Jr. over to take a look. Dan spent a fair amount of time analyzing the existing door (which is super heavy and rather beat-up), and then when I subsequently tried to open the door manually and nearly killed myself (true and embarrassing), both Dans came to the new house and a huge amount of time (again without charge) trying to help us out. We ultimately decided to replace the garage door on our new house with exactly the same door we installed on our old house, and Dan and Dan have worked hard to ensure that they can get it done more quickly than one would normally expect. Dan and Dan truly set the standard for customer service and quality installation."
			},
			{
				initials: "Fred D",
				name: "Fred D",
				location: "Montara, CA",
				rating: 5,
				text: "Dan and his Son Dan jr. are great, their a family business on the Coast, they respond quickly, both of them very polite and professional, very fair prices, I would call them again with no hesitation for repairs or door replacement. Job well done ..........Fred"
			},
			{
				initials: "Dan L",
				name: "Dan L",
				location: "Anderson, CA",
				rating: 5,
				text: "Absolute professionalism. We have had a few appointments and they were early and ready to take care of business. Today my new doors and openers are being installed. I'm impressed with the quality of work being done and their willingness to answer any questions."
			}
		];

		return (
      <div>
        {/* Header */}
        <div className="primary-background large-padding centered-text">
          <h1 className="white">Customer Testimonials</h1>
          <p className="white subheading">See what our customers are saying about our service</p>
        </div>

        {/* Testimonials Cards - Stacked Vertically */}
        <div className="light-grey-background large-padding">
          <div className="row">
            <div className="small-12 medium-6 large-6" style={{margin: "0 auto"}}>
              {testimonials.map((testimonial, index) => (
                <div key={index} style={{marginBottom: "30px"}}>
                  <div style={{
                    display: "flex",
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff"
                  }}>
                    {/* Left Panel - Dark Blue with Yelp Branding */}
                    <div className="primary-background" style={{
                      width: "120px",
                      padding: "20px 15px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <img src="/images/yelp-logo.png" alt="Yelp" style={{
                        width: "40px",
                        height: "40px",
                        marginBottom: "15px"
                      }} />
                      <div style={{marginBottom: "10px"}}>
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <span key={i} style={{color: "#c60c00", fontSize: "16px"}}>★</span>
                        ))}
                      </div>
                      <div className="white" style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        textAlign: "center"
                      }}>
                        {testimonial.initials}
                      </div>
                      <div className="white" style={{
                        fontSize: "12px",
                        textAlign: "center",
                        opacity: 0.8
                      }}>
                        {testimonial.location}
                      </div>
                    </div>

                    {/* Right Panel - White with Review Text */}
                    <div style={{
                      flex: 1,
                      padding: "20px",
                      backgroundColor: "#fff"
                    }}>
                      <p style={{
                        margin: 0,
                        lineHeight: "1.6",
                        fontSize: "14px",
                        color: "#333"
                      }}>
                        "{testimonial.text}"
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/testimonials/index.js